import { render, staticRenderFns } from "./TaxObligation.vue?vue&type=template&id=c6daa490&"
import script from "./TaxObligation.vue?vue&type=script&lang=ts&"
export * from "./TaxObligation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports